import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { SchoolInformationFormComponent } from '../../../components/school/school-information-form/school-information-form.component';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { SearchComponent } from '../../../components/search/search.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';
import { PageHeaderComponent } from "../../../components/page-header/page-header.component";

@Component({
  selector: 'app-school-index',
  standalone: true,
  imports: [
    CommonModule,
    SchoolInformationFormComponent,
    LoaderComponent,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
    PaginationComponent,
    SearchComponent,
    TableGuruComponent,
    PageHeaderComponent
  ],
  templateUrl: './school-index.component.html',
  styleUrl: './school-index.component.scss'
})
export class SchoolIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  editFormReference = SchoolInformationFormComponent;

  constructor() { }

  ngOnChanges(changes: any) {
    if (this.reloadItems === true) {
      setTimeout(() => {
        this.reloadItems = false;
      }, 1000);
    }
  }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(SchoolInformationFormComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = { };
    modalRef.componentInstance.modalInstance = modalRef;

    modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }
}
